<template>
    <div class="containter m-5 grid">
      <card  class=" col-10   surface-50">
        <template #title>
            <Card>
              <template #title> 
                <span class="text-700">Confirmación</span>   
              </template>
              <template #content>
                <div class="grid ">
                    <div class="col-10">
                      <table class="greyGridTable">
                        <tbody>
                          <tr>
                            <th>Expediente</th>
                            <td class="font-semibold">{{ edoCuenta.expediente}}</td>
                          </tr>
                          <tr v-if="false">
                            <th>Nombre</th>
                            <td>{{ edoCuenta.nombre}}</td>
                          </tr>
                          <tr>
                            <th>Ubicación Predio</th>
                            <td>{{ edoCuenta.ubicacion}}</td>
                          </tr>
                          <tr >
                            <td colspan="2">
                             
                            </td>
                          </tr>
                          <tr>
                            <th>Saldo a Pagar:</th>
                            <td class="font-bold  text-gray-800 text-lg"> {{ formatCurrency(edoCuenta.saldo)}} </td>
                          </tr>
                          

                        </tbody>
                      </table>
                    </div>
                </div>
              </template>

            </Card>
            <form ref="form" method="post" >
              <input type="hidden" name="mp_account" ref="mp_account" value="13340">
              <input type="hidden" name="mp_product" ref="mp_product" value="1">
              <input type="hidden" name="mp_order" ref="mp_order" value="">
              <input type="hidden" name="mp_reference" ref="mp_reference" value="">
              <input type="hidden" name="mp_node" ref="mp_node" value="0">
              <input type="hidden" name="mp_concept" ref="mp_concept" value="1">
              <input type="hidden" name="mp_amount" ref="mp_amount" value="">
              <input type="hidden" name="mp_customername" ref="mp_customername" value="">
              <input type="hidden" name="mp_currency" ref="mp_currency" value="1">
              <input type="hidden" name="mp_signature" ref="mp_signature" value="">
              <input type="hidden" name="mp_urlsuccess" ref="mp_urlsuccess" value="">
              <input type="hidden" name="mp_urlfailure" ref="mp_urlfailure" value="">
          </form>
                  
        </template>
        <template #content>
             

        </template>
        <template #footer>
          <div class="flex justify-content-around flex-wrap w-full ">
            <div class="flex align-items-center justify-content-center col-4">
              <Button icon="pi pi-backward" label="Empezar" class="p-button-info " @click="goHome" />
            </div>
            <div class="flex align-items-center justify-content-center col-4">
              <Button icon="pi pi-wallet" label="Pagar en Banco" class="p-button-warning " @click="redirecciona" />
            </div>
          </div>
        </template>
    </card>
  </div>
 </template>
 
<script>
 import { ref } from '@vue/reactivity';
 import predialAPI from "@/composables/PredialAPI";
 import edoCuentaStore from "@/composables/edoCuentaStore";


export default {
    setup(props,{ emit }) {
      const dataset =  ref([]);
      const { getExpediente,getSignature,generaOrden } = predialAPI();
      const {getEdoCuentaFromStore} = edoCuentaStore();
      let edoCuenta= ref({
        expediente:'',
        nombre:'',
        ubicacion:'',
        saldo:0.0,
        numCarga:0
      })

   // expose to template and other options API hooks
   return {
     emit,dataset,getEdoCuentaFromStore,getExpediente,edoCuenta,getSignature,generaOrden 
   }
 },
 methods: {
    formatNumeric(number) {
        return  new Intl.NumberFormat().format(number)
    },
    formatCurrency(number) {
        const tipoMoneda = { style: 'currency', currency: 'USD' };
        return new Intl.NumberFormat('en-US', tipoMoneda).format(number);
    },
    obtenTotales() {
      const sumatoria= (acum, val) => {
          if (val.conceptoClave == 5) 
            return acum - val.importe
          else
            return acum + val.importe
      }
      return this.dataset.conceptos.reduce(sumatoria, 0);
    },
    comprobante() {
    this.emit("currentStep",4)
  },
  goHome() {
    this.emit("currentStep",1)
  },
  async redirecciona() {
    // Aqui vamos
    // Generamos la OC.
    const oc = await this.generaOrden(this.edoCuenta.expediente,this.edoCuenta.numCarga)

    // Poblamos los campos requeridos por Multipados
    // Hacemos el FWD
    this.$refs.form.action=process.env.VUE_APP_URL_MULTIPAGOS  
    this.$refs.mp_account.value = process.env.VUE_APP_MP_ACCOUNT  
    this.$refs.mp_order.value = oc.idOrden
    this.$refs.mp_reference.value =  oc.expediente + "c" + oc.numCarga 
    this.$refs.mp_amount.value =   this.edoCuenta.saldo
    this.$refs.mp_customername.value =  this.edoCuenta.nombre
    this.$refs.mp_urlsuccess.value = oc.urlExito
    this.$refs.mp_urlfailure.value = oc.urlError
    this.$refs.mp_signature.value= await this.getSignature( oc.idOrden,this.$refs.mp_reference.value, this.edoCuenta.saldo);
    console.log( this.$refs.mp_signature.value);
    this.$refs.form.submit()
  },
  async cargaInfo() {
    this.edoCuenta= await this.getEdoCuentaFromStore()
    
    if (this.edoCuenta.id == 0) {
      this.goHome()
      return;
    }

    this.dataset = await this.getExpediente(this.edoCuenta.expediente)
    this.edoCuenta.expediente=this.dataset.expediente
    this.edoCuenta.nombre=this.dataset.nombre
    

    this.edoCuenta.saldo=this.obtenTotales().toFixed(2);
    this.edoCuenta.ubicacion=this.dataset.ubicacionPredio
    this.edoCuenta.numCarga=this.dataset.numCarga
  }
 },
 mounted() {
   this.cargaInfo()
  
 }
}
</script>
<style lang="scss">
table.greyGridTable {
  border: 2px solid #FFFFFF;
  width: 100%;
  text-align: left;
  border-collapse: collapse;
}
table.greyGridTable td, table.greyGridTable th {
  border: 1px solid #FFFFFF;
  padding: 3px 4px;
}
table.greyGridTable tbody td {
  font-size: 13px;
}
table.greyGridTable tbody .mlp {
  background-color: rgb(233, 233, 252);
  font-size: 3px;
  height: 3px;
  margin: 0;
}

table.greyGridTable tbody th {
  width: 15%;
  background: #fcf5fc;
}
table.greyGridTable td:nth-child(even) {
  background: #EBEBEB;
}
table.greyGridTable thead {
  background: #FFFFFF;
  border-bottom: 4px solid #333333;
}
table.greyGridTable thead th {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  border-left: 2px solid #333333;
}
table.greyGridTable thead th:first-child {
  border-left: none;
}

table.greyGridTable tfoot {
  font-size: 14px;
  font-weight: bold;
  color: #333333;
  border-top: 4px solid #333333;
}
table.greyGridTable tfoot td {
  font-size: 14px;
}
.saldoAPagar {
  font-size:  xx-large;
  font-weight: 800;
   
}
 </style>